import React, { useContext } from "react";
import MyContext from "../context/MyContext";
import { Link, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { AddShoppingCart } from "@material-ui/icons";
import axios from "axios";
import Slider from "./Slider";

const ProductItem = ({ product, deleteProduct, handleCheck }) => {
  const context = useContext(MyContext);
  const { isAdmin, user, cart, setCart } = context;
  const history = useHistory();

  const addCart = async (product) => {
    const check = cart.every((item) => {
      return item._id !== product._id;
    });
    if (check) {
      setCart([...cart, { ...product, quantity: 1 }]);
      await axios.patch("/users/addcart",{ cart: [...cart, { ...product, quantity: 1 }] });
    } else {
      alert("This product has been added to cart.");
    }
  };

  const checkUser = (product) => {
    if (!user) {
      alert("Please login");
      history.push("/login");
    } else {
      addCart(product);
    }
  };

  return (
    <div className="product_card">
      <div>
        {isAdmin && (
          <input
            type="checkbox"
            checked={product.checked}
            onChange={() => handleCheck(product._id)}
          />
        )}

        <Slider data={product.images} ></Slider>

        <Link to={`/detail/${product._id}`}>
          <div className="product_box">
            <h2 title={product.title}>{product.title}</h2>
            <span>{product.price} €</span>
            <p>{product.description}</p>
          </div>
        </Link>
      </div>
      <div className="row_btn">
        {isAdmin ? (
          <>
            <Link
              id="btn_buy"
              to="#!"
              onClick={() =>
                deleteProduct(product._id, product.images.public_id)
              }
            >
              Delete
            </Link>
            <Link id="btn_view" to={`/edit_product/${product._id}`}>
              Edit
            </Link>
          </>
        ) : (
          <div className="addToCart">
            <Button to="#!" onClick={() => checkUser(product)}>
              <AddShoppingCart />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductItem;
